<template>
  <div class="panel_shouyin">
    <div class="titleLine">
      <el-row>
        <el-col :span="10">
          录入礼品卡号：
          <el-input
            size="mini"
            style="width: 250px"
            v-model="scanningCodeInput"
            @keyup.enter.native="clickScanningCodeInput"
            placeholder="请录入礼品卡号"
          >
          </el-input>
        </el-col>
        <el-col :span="2" :offset="12">
          <!-- 购买商品： -->
          <el-button
            size="mini"
            @click="$store.commit('mendian/set_curBusiness', '消费')"
            >购买商品</el-button
          >
        </el-col>
      </el-row>
    </div>
    <div class="tableBox" ref="tableBox">
      <el-table :data="tableData" height="100%" style="width: 100%" size="mini">
        <el-table-column label="礼品卡名称" min-width="110">
          <template slot-scope="scope">
            {{ scope.row.card_name }}
          </template>
        </el-table-column>
        <el-table-column label="卡号" min-width="110">
          <template slot-scope="scope">
            {{ scope.row.card_number }}
          </template>
        </el-table-column>
        <el-table-column label="类型" min-width="100">
          <template slot-scope="scope">
            {{ scope.row.card_type.title }}
          </template>
        </el-table-column>
        <el-table-column label="面额" min-width="80">
          <template slot-scope="scope">
            {{ scope.row.price }}
          </template>
        </el-table-column>
        <el-table-column label="销售人员" min-width="110">
          <template slot-scope="scope">
            <el-select
              :disabled="scope.row.card_type.value == '2'"
              v-model="scope.row.staff"
              @change="changeStaff(scope.$index, scope.row)"
              multiple
              filterable
              placeholder="请选择"
              size="mini"
            >
              <el-option
                popper-class="select"
                v-for="item in staffList"
                :key="item._id"
                :label="item.basic_info.nick_name"
                :value="item._id + ',' + item.basic_info.nick_name"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="80">
          <template slot-scope="scope">
            <span>
              <span>
                <img
                  class="btn_operate"
                  @click="del_giftCard(scope.$index)"
                  src="../../../../assets/img/shanchu.png"
                />
              </span>
            </span>
          </template>
        </el-table-column>
        <span slot="empty">
          <img
            src="../../../../assets/img/kong.png"
            style="width: 340px; padding-top: 0px"
          />
          <div style="font-size: 14px; color: #333; margin: 0px">
            请用扫码枪扫描商品码
          </div>
        </span>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 扫码
      scanningCodeInput: "",
      // 列表
      tableData: [],
      // 销售人员
      staffList: [],
    };
  },
  computed: {
    userInfo() {
      if (this.$store.state.mendian.userInfo._id) {
        return this.$store.state.mendian.userInfo;
      } else {
        return {
          basic_info: {},
          card_info: {},
          company_info: {},
          operation_info: {},
          pets_info: [],
          club_card: {},
        };
      }
    },
    saleList() {
      return this.$store.state.saleGiftCard.saleList;
    },
  },
  watch: {
    saleList(n) {
      this.tableData = n;
    },
  },
  mounted() {
    this.getStaffList();
    this.tableData = this.saleList;
  },
  methods: {
    ////////////////////////////////////////////////////////// 商品
    clickScanningCodeInput() {
      if (this.$public.isNull(this.userInfo._id)) {
        this.$message({
          message: "请选择顾客",
          type: "error",
        });
      } else {
        this.getScanData(this.scanningCodeInput);
      }
      this.$nextTick(() => {
        this.scanningCodeInput = "";
      });
    },
    getScanData(code) {
      let loading = this.$loading();
      this.$http
        .get(process.env.VUE_APP_Url_member + "/api/GiftCard/single", {
          cardNumber: code,
        })
        .then((res) => {
          loading.close();
          if (res.code === 0) {
            if (this.$public.isNull(res.data)) {
              this.$message({
                message: "未获取到礼品卡信息",
                type: "error",
              });
              return;
            }
            let d = res.data;
            if (d.card_state.value !== "1") {
              this.$message({
                message: "状态错误，不可销售",
                type: "error",
              });
              return;
            }
            if (d.sale_state.value === "2") {
              this.$message({
                message: "已销售，不可再次销售",
                type: "error",
              });
              return;
            }
            console.log("礼品卡", res.data);
            res.data.staff = [];
            this.tableData.push(res.data);
            this.$store.commit("saleGiftCard/set_saleList", this.tableData);
          }
        });
    },
    // 删除
    del_giftCard(index) {
      this.$confirm("确定要删除?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.tableData.splice(index, 1);
        this.$store.commit("saleGiftCard/set_saleList", this.tableData);
      });
    },
    //////////////////////////////////////////////////////// 销售人员
    changeStaff(index) {
      // if (index == 0) {
      //   for (let i = 0; i < this.tableData.length; i++) {
      //     this.tableData[i].staff = this.tableData[0].staff;
      //   }
      // }
      console.log(this.tableData,'this.tableData');
      this.$store.commit("saleGiftCard/set_saleList", this.tableData);
    },
    getStaffList() {
      let params = {
        keyword: "",
        pageIndex: 1,
        pageSize: 500,
      };
      this.$http.get("/api/Staff/List", params).then((res) => {
        if (res.code == 0) {
          this.staffList = res.data.data;
          // console.log(this.staffList);
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.panel_shouyin {
  padding-bottom: 65px;
  box-sizing: border-box;
  height: 100%;
  position: relative;
  .titleLine {
    position: absolute;
    z-index: 1;
    width: 100%;
    background-color: #fff;
    height: 48px;
    padding: 12px 12px 12px 12px;
    box-sizing: border-box;
    font-size: 14px;
    color: $fontColor;
    .taskBox {
      display: flex;
      padding-top: 4px;
      .taskItem {
        display: flex;
        align-items: center;
        padding: 0 20px;
        border-right: 2px solid #f5f5f5;
        cursor: pointer;
        &:last-child {
          border-right: 0;
        }
        .taskNum {
          font-size: 12px;
          color: #fff;
          margin-right: 4px;
          background-color: #ff182a;
          border-radius: 50%;
          width: 20px;
          line-height: 20px;
          text-align: center;
        }
        .taskText {
          font-size: 14px;
          color: #1890ff;
          padding-right: 4px;
        }
        .taskNext {
          width: 4px;
          height: 7px;
        }
      }
    }
  }
  .tableBox {
    height: 100%;
    padding-top: 48px;
    box-sizing: border-box;
  }
  .btn_operate {
    width: 10px;
    height: 10px;
    padding-right: 5px;
    cursor: pointer;
  }
}
</style>
